import script from "./ChangePasswordModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangePasswordModal.vue?vue&type=script&setup=true&lang=js"

import "./ChangePasswordModal.vue?vue&type=style&index=0&id=2ea1ae6e&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ea1ae6e"]])

export default __exports__